document.addEventListener("DOMContentLoaded", function () {
  const thumbs = document.querySelectorAll(".theme-thumb-btn");
  const slides = document.querySelectorAll(".theme-images .swiper-slide");

  // 👉 Asegurar que el primer slide tenga current-img al inicio
  if (slides.length > 0) {
    slides.forEach(s => s.classList.remove("current-img"));
    slides[0].classList.add("current-img");
  }

  // 👉 Función para mostrar la imagen por mediaId
  function showImageByMediaId(mediaId) {
    const targetSlide = document.querySelector(`.theme-images .swiper-slide [data-media-id="${mediaId}"]`);
    if (targetSlide) {
      slides.forEach(s => s.classList.remove("current-img"));
      const parentSlide = targetSlide.closest(".swiper-slide");
      if (parentSlide) {
        parentSlide.classList.add("current-img");
      }
    }
  }

  // 👉 Listener en thumbnails
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const mediaId = thumb.getAttribute("data-media-id");
      showImageByMediaId(mediaId);

      // Actualizar clases activas en thumbs
      document.querySelectorAll(".theme-thumb-btn").forEach(t => t.classList.remove("thumb-active"));
      thumb.classList.add("thumb-active");
    });
  });

  // 👉 Listener en las variantes (los <a> dentro de clickyboxes)
  document.querySelectorAll(".clickyboxes a").forEach(opt => {
    opt.addEventListener("click", (e) => {
      e.preventDefault();
      const value = opt.getAttribute("data-value");

      // Buscar el <option> que tenga ese value
      const relatedOption = document.querySelector(`select option[value="${value}"]`);
      if (relatedOption) {
        const mediaId = relatedOption.getAttribute("data-media-id");
        if (mediaId) {
          showImageByMediaId(mediaId);
        }
      }
    });
  });
});
